import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {AutoModInvitesOptions} from "@/types/GuildSettings";


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoModInvitesOptions',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit


return (_ctx: any,_cache: any) => {
  const _component_v_combobox = _resolveComponent("v-combobox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_combobox, {
      modelValue: props.modelValue.whitelistGuilds,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.modelValue.whitelistGuilds) = $event)),
      onSubmit: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', props.modelValue))),
      color: "primary",
      label: _ctx.$t('GuildModeration.subtitles.allowedGuilds'),
      chips: "",
      "closable-chips": "",
      multiple: ""
    }, null, 8, ["modelValue", "label"])
  ]))
}
}

})